import { render, staticRenderFns } from "./CellarWineListComponent.vue?vue&type=template&id=58a56820&scoped=true"
import script from "./CellarWineListComponent.vue?vue&type=script&lang=js"
export * from "./CellarWineListComponent.vue?vue&type=script&lang=js"
import style0 from "./CellarWineListComponent.vue?vue&type=style&index=0&id=58a56820&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a56820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a56820')) {
      api.createRecord('58a56820', component.options)
    } else {
      api.reload('58a56820', component.options)
    }
    module.hot.accept("./CellarWineListComponent.vue?vue&type=template&id=58a56820&scoped=true", function () {
      api.rerender('58a56820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cellarwine/CellarWineListComponent.vue"
export default component.exports